import * as clientService from "./httpsClient";

export const getHistory = async (params) => {
  try {
    const domain = `history`;
    const accessToken = localStorage.getItem("token");
    return await clientService.getApi(domain, accessToken, params);
  } catch (error) {
    console.log("[getHistory] error", error);
    throw error;
  }
};
